module.exports = "https://static.wmbcdn.com/uniweb/images/e9c25c4dcd6bcfee3568edb8f45bd536.svg";